const forumlaEditorColumns =[
  {
    // title: '配方名称',
    dataIndex: 'formulaName',
    scopedSlots: {customRender: 'formulaName'},
    slots: { title: 'customTitle' },
    fixed: 'left',
    sorter: (a, b) => a.formulaName.localeCompare(b.formulaName,'zh'),
    width:140
  },
  {
    title: '代码',
    dataIndex: 'formulaCode',
    sorter: (a, b) => a.formulaCode.localeCompare(b.formulaCode),
    width: 120
  },
  {
    title: '同步时间',
    dataIndex: 'syncTime',
    // sorter: (a, b) => a.formulaCode.localeCompare(b.formulaCode),
    width: 120,
    scopedSlots: {customRender: 'synchronizeTime'},
  },
  {
    title: '预计产量(吨)',
    dataIndex: 'estimateOutput',
    scopedSlots: {customRender: 'estimateOutput'},
    sorter: (a, b) => a.estimateOutput - b.estimateOutput,
    align:'center',
    width:100
  },
  {
    title: '价格(元/吨)',
    dataIndex: 'taskPrice',
    scopedSlots: {customRender: 'taskPrice'},
    sorter: (a, b) => a.taskPrice - b.taskPrice,
    align:'center',
    width:100
  },
  {
    title: '产品(元/吨)',
    dataIndex: 'productPrice',
    scopedSlots: {customRender: 'productPrice'},
    sorter: (a, b) => a.productPrice - b.productPrice,
    align:'center',
    width:100
  },
   {
    // title: '上一次配方优化价格(元/吨)',
    title: '历史价格(元/吨)',
    dataIndex: 'formulaPrice',
    scopedSlots: {customRender: 'formulaPrice'},
    sorter: (a, b) => a.formulaPrice - b.formulaPrice,
    align:'center',
    width:150
  },
  {
    title: '差价(元/吨)',
    dataIndex: 'productDiffPrice',
    scopedSlots: {customRender: 'productDiffPrice'},
    sorter: (a, b) => a.productDiffPrice - b.productDiffPrice,
    align:'center',
    width:100
  },
]

export default forumlaEditorColumns